export default "__VITE_ASSET__9UeC11vZ__"